import { contract_tab, info_tab, versioning_tab } from '../../../../../../views/contract/agreement';

export default {
  title: 'Sopimuksen tiedot',
  tabs: {
    [info_tab]: 'Tiedot',
    [contract_tab]: 'Sopimus',
    [versioning_tab]: 'Versiointi',
  },
  sections: {
    price_info: 'Hintatiedot',
    contact: 'Nykyinen sopimus',
    signature_history: 'Allekirjoitushistoria',
  },
  labels: {
    not_signed: 'Sopimusta ei ole vielä allekirjoitettu',
  },
  modals: {
    preview_contract: {
      title: 'Esikatsele sopimusta',
    },
    switch_to_annual: {
      title: 'Vaihda vuosilaskutukseen',
    },
  },
  buttons: {
    save: 'Tallenna',
    preview_and_sign: 'Esikatsele ja allekirjoita',
    download: 'Lataa',
    switch_to_annual: 'Vaihda vuosilaskutukseen',
  },
  toasts: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
    failed_to_save_changes: 'Muutosten tallentaminen epäonnistui',
    changes_got_saved: 'Muutokset tallennettu',
  },
};
